import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "review-submitted" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"review-submitted__checkmark\"><svg width=\"58\" height=\"58\" viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"29\" cy=\"29\" r=\"29\" fill=\"#1BB0A8\"></circle><line x1=\"17.5415\" y1=\"31.5\" x2=\"25.0833\" y2=\"39.0418\" stroke=\"white\" stroke-width=\"2.18\" stroke-linecap=\"round\"></line><line x1=\"25.0833\" y1=\"39.0419\" x2=\"41.7085\" y2=\"22.4167\" stroke=\"white\" stroke-width=\"2.18\" stroke-linecap=\"round\"></line></svg></div>", 1)
const _hoisted_3 = { class: "review-submitted__caption" }
const _hoisted_4 = { class: "review-submitted__text" }

import { onBeforeUnmount } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewSubmitted',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const { mitt } = useContext();

onBeforeUnmount(() => {
  mitt.emit('Tycka:Review:ReviewSubmit:Close');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(websiteText)('review__review_submitted_caption').value ||
        'review__review_submitted_caption'), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('review__review_submitted_text').value ||
        'review__review_submitted_text'), 1)
  ]))
}
}

})